const getters = {
  getAgcPermission: state => id => {
    return state.accountAuth.getAgcPermissionById(id)
  },
  getAdvPermission: state => (agcId, advId) => {
    return state.accountAuth.getAdvPermissionById(agcId, advId)
  },
  getInsPermission: state => (agcId, advId, insId) => {
    return state.accountAuth.getInsPermissionById(agcId, advId, insId)
  },
}

export default getters
